import {songs as songs_2020, images as images_2020} from "./2020/index.ts";
import {songs as songs_dummy, images as images_dummy, acoustic_images, acoustic_songs} from "./dummy/index.ts";
export type Page = {
    title: string,
    url: string,
    images: {image: any, id: number}[],
    songs: {song: any, id: number, title: string, artist: string}[],
}

export default [
    {
        title: "2020",
        url: "2020",
        images: images_2020,
        songs: songs_2020
    },
    {
        title: "2021",
        url: "2021",
        images: images_dummy,
        songs: songs_dummy
    },
    {
        title: "2022",
        url: "2022",
        images: images_dummy,
        songs: songs_dummy
    },
    {
        title: "2023",
        url: "2023",
        images: images_dummy,
        songs: songs_dummy
    },
    {
        title: "2024",
        url: "2024",
        images: images_dummy,
        songs: songs_dummy
    },
    {
        title: "Acoustic set",
        url: "acoustic-set",
        images: acoustic_images,
        songs: acoustic_songs,
    },
] as Page[];